import { AgChartTheme } from 'ag-charts-community';
import { darkMuiTheme } from './darkMuiTheme';

export const darkAgChartTheme: AgChartTheme = {
    baseTheme: 'ag-default-dark',

    palette: {
        fills: ['#60A5FA', '#F97316', '#4ADE80', '#DC2626', '#FBBF24', '#A78BFA', '#F472B6'],
        strokes: ['#1D4ED8', '#C2410C', '#15803D', '#991B1B', '#B45309', '#6D28D9', '#BE185D'],
    },
    params: { accentColor: darkMuiTheme.palette.secondary.main },
};
